import { render, staticRenderFns } from "./FreeSpeakingConfigModal.vue?vue&type=template&id=346d1a68&scoped=true&"
import script from "./FreeSpeakingConfigModal.vue?vue&type=script&lang=ts&"
export * from "./FreeSpeakingConfigModal.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=346d1a68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346d1a68",
  null
  
)

export default component.exports